






























import {Component, Prop, Vue} from 'vue-property-decorator'
import {currencyValidator} from "@/util/currencyValidator";
import {uniqueId} from "@/util/uniqueId";

@Component
export default class AmountInput extends Vue {
    @Prop({
        default: 0
    })
    value!: number;

    @Prop({
        default: false
    })
    isRequired!: boolean;

    @Prop({
        default: true
    })
    isEditable!: boolean;

    @Prop({
        default: null
    })
    tooltip?: string | null;

    @Prop()
    label!: string;

    @Prop()
    name?: string;

    @Prop()
    error?: string | null;

    @Prop()
    warning?: string | null;

    private uid = uniqueId();

    mounted() {
        this.formatValue();
    }

    allowKeyInput(event: KeyboardEvent) {
        const allowingInput = event.code !== 'Minus';
        if (!allowingInput) {
            event.preventDefault();
        }
    }

    updateValue(value: string) {
        const result = currencyValidator.parse(value, this.value);
        if (result.warning) {
            console.warn(result.warning);
            this.setInputValue(currencyValidator.format(result.value));
        }

        this.$emit('input', result.value);
    }

    formatValue() {
        const val = this.value;
        // noinspection SuspiciousTypeOfGuard
        if (typeof val === 'string') {
            this.value = parseFloat(val);
        }
        this.setInputValue(currencyValidator.format(this.value));
    }

    setInputValue(value: string) {
        const input = this.$refs.input as (HTMLInputElement | null);
        if (input) {
            input.value = value;
        }
    }

    selectAll(event: any) {
        // Workaround for Safari bug
        // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
        setTimeout(function () {
            event.target.select();
        }, 0);
    }
}
